<template>
  <div></div>
</template>

<script>
export default {
  name: 'Home',
  data() {

  },
  created() {
    window.open(process.env.VUE_APP_TOP_DOMAIN, '_self')
  }
}
</script>